import styled, { css } from "styled-components";

export default {
    "Wrapper": styled.div`
        display: flex;
        gap: 16px;
    `,
    "Area": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;

        ${({ $expand }) => $expand && css`
            flex: 1;
        `}

        & > h2 {
            width: 100%;
            ${({ theme }) => theme.font.extra_small_bold};
        }
    `
}